<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconVideoOn_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M5.65 7h8.75a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5H5.65a2.5 2.5 0 0 1-2.5-2.5v-5A2.5 2.5 0 0 1 5.65 7m12.5 3.125 2.725-2.271a.625.625 0 0 1 1.025.48v7.332c0 .53-.618.819-1.025.48l-2.725-2.271z"
        clip-rule="evenodd"
    />
</svg>
